module.exports = __webpack_public_path__ + "img/protection of cerpinus.787929ab.png";